import { render } from "./AboutView.vue?vue&type=template&id=225825b3"
const script = {}

import "./AboutView.vue?vue&type=style&index=0&id=225825b3&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__